import { gql } from '@apollo/client';

const HIKE_FIELDS = `
  id
  title
  location
  hikeDate
  status
  distance
  distanceUnit
  elevationGain
  elevationUnit
  durationMinutes
  difficulty
  trailType
  terrain
  latitude
  longitude
  hasRouteGeometry
  geometrySummary
  routeUrl
  mapUrl
  permitRequired
  dogFriendly
  kidFriendly
  rating
  favorite
  startTime
  parkingNotes
  companions
  weather
  trailCondition
  crowdLevel
  actualDistance
  actualDurationMinutes
  notes
  checklist {
    id
    title
    packed
  }
  tags
  tripId
  tripTitle
  tripDayId
  tripDayTitle
  createdAt
  updatedAt
  trailCatalogId
  trailSource
  trailSourceId
  coverPhotoUrl
  coverPhotoUpdatedAt
`;

const HIKE_LIST_FIELDS = `
  id
  title
  location
  hikeDate
  status
  distance
  distanceUnit
  durationMinutes
  difficulty
  trailType
  terrain
  favorite
  tags
  tripTitle
  tripDayId
  tripDayTitle
  coverPhotoUrl
  coverPhotoUpdatedAt
`;

export const GET_HIKES = gql`
  query GetHikes($first: Int, $after: String) {
    getHikesListPage(first: $first, after: $after) {
      nodes {
        ${HIKE_LIST_FIELDS}
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const GET_HIKE = gql`
  query GetHike($id: ID!) {
    getHike(id: $id) {
      ${HIKE_FIELDS}
    }
  }
`;

export const ADD_HIKE = gql`
  mutation AddHike($input: HikeInput!) {
    addHike(input: $input) {
      ${HIKE_FIELDS}
    }
  }
`;

export const UPDATE_HIKE = gql`
  mutation UpdateHike($id: ID!, $input: HikeInput!) {
    updateHike(id: $id, input: $input) {
      ${HIKE_FIELDS}
    }
  }
`;

export const DELETE_HIKE = gql`
  mutation DeleteHike($id: ID!) {
    deleteHike(id: $id)
  }
`;

export const SEARCH_TRAILS = gql`
  query SearchTrails($query: String!) {
    searchTrails(query: $query) {
      trailId
      trailCatalogId
      source
      sourceId
      title
      location
      latitude
      longitude
      distance
      distanceUnit
      elevationGain
      elevationUnit
      durationMinutes
      difficulty
      trailType
      terrain
      routeUrl
      mapUrl
      permitRequired
      dogFriendly
      kidFriendly
      tags
      notes
      attribution
      fetchedAt
      enrichedAt
      hasRouteGeometry
      geometrySummary
    }
  }
`;

export const ENRICH_TRAIL = gql`
  mutation EnrichTrail($input: TrailSelectionInput!) {
    enrichTrail(input: $input) {
      trailId
      trailCatalogId
      source
      sourceId
      title
      location
      latitude
      longitude
      distance
      distanceUnit
      elevationGain
      elevationUnit
      durationMinutes
      difficulty
      trailType
      terrain
      routeUrl
      mapUrl
      permitRequired
      dogFriendly
      kidFriendly
      tags
      notes
      attribution
      fetchedAt
      enrichedAt
      hasRouteGeometry
      geometrySummary
    }
  }
`;
